import { get, map, find } from "lodash"
import { createSelector } from "reselect"
import { STYLE_AGGREGATION_OPTIONS, AGGREGATION_FUNCTIONS } from "helpers/factorClassification"
import { COLORS } from "helpers/analyzeConstants"
import { createQueryStringSelector } from "selectors/queryString"
import { CONTENT_SET_DATA_TYPES } from "helpers/contentSetConstants"
import { METRIC_TYPES } from "helpers/assets/constants"

const EMPTY_ARRAY = []

export const getContentSetId = (_, props) => props.contentSetId
export const getContentSets = state => get(state, "global.data.contentSets.data.contentSets")
export const getFocusedChartLine = state => get(state, "modules.analyzeCompositeExposure.focusedChartLine")
export const getFactorCategoryId = createQueryStringSelector("factorCategory", "style")
export const getOnly = createQueryStringSelector("only")
export const getDisabled = createQueryStringSelector("disabled", EMPTY_ARRAY)
export const getAggregationFunction = createQueryStringSelector("styleAggregation", AGGREGATION_FUNCTIONS.NONE)

const getModelDisplayAddView = (_, props) => props.displayAddView
const getModelCategories = (_, props) => props.categories
const getMustAggregateFactors = (_, props) => props.mustAggregateFactors

export const getStyleAggregation = createSelector(
  [getMustAggregateFactors],
  (mustAggregateFactors) => ({
    displayAggregationToggle: mustAggregateFactors,
    aggregationOptions: STYLE_AGGREGATION_OPTIONS,
  }),
)

export const getCategories = createSelector(
  [getModelCategories, getContentSets, getContentSetId],
  (categories, contentSets, contentSetId) => {
    if (contentSetId) {
      const contentSet = find(contentSets, ({ id }) => id === contentSetId)
      if (contentSet) {
        return map(contentSet.categories, ({ id, name }, index) => ({
          id, label: name, color: COLORS[index],
        }))
      }
      return null
    }

    return categories
  },
)

export const getDisplayAggregationToggle = createSelector(
  [getFactorCategoryId, getMustAggregateFactors],
  (factorCategory, mustAggregateFactors) => mustAggregateFactors && factorCategory === "style",
)

export const getDisplayAddView = createSelector(
  [getModelDisplayAddView, getContentSetId],
  (displayAddView, contentSetId) => displayAddView && !contentSetId,
)

export const getIsSensitivityContentSet = createSelector(
  [getContentSets, getContentSetId],
  (contentSets, selectedContentSetId) => {
    const contentSet = find(contentSets, { id: selectedContentSetId })
    return contentSet ? contentSet.dataType === CONTENT_SET_DATA_TYPES.SENSITIVITY : false
  },
)

export const getMetricType = createSelector(
  [getIsSensitivityContentSet, getContentSetId],
  (isSensitivityContentSet, selectedContentSetId) => {
    if (selectedContentSetId) {
      return isSensitivityContentSet ? METRIC_TYPES.CURRENCY_EXPOSURE : METRIC_TYPES.NET_CONTRIBUTION
    }

    return METRIC_TYPES.NET_CONTRIBUTION
  },
)
